// extracted by mini-css-extract-plugin
export var desktopNavigation = "Navigation-module--desktopNavigation--3d761";
export var mobileNavigation = "Navigation-module--mobileNavigation--68276";
export var productInfoContainer = "Navigation-module--productInfoContainer--997e2";